import { TableCell, TableRow } from '@hivewatch/dark'

import { GuardToursRowDataType } from '../types/table'
import { GuardToursColumnIProps } from './Columns'

interface GuardToursTableRowIProps {
  columns: GuardToursColumnIProps[]
  row: GuardToursRowDataType
  onClick: (row: GuardToursRowDataType) => void
}

export const GuardToursTableRow = ({
  columns,
  row,
  onClick,
}: GuardToursTableRowIProps) => {
  return (
    <TableRow onClick={() => onClick(row)}>
      {columns.map((col) => (
        <TableCell key={col.key} {...col.style}>
          {col.cell(row)}
        </TableCell>
      ))}
    </TableRow>
  )
}
